<template>
	<div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">
                        
                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">
                                            <h4>Discontinued Applications</h4>

                                            <div class="table-responsive">
                                                <input type="text" class="form-control" v-model="starred_filter" placeholder="Search...">
                                                <datatable :columns="starred_columns" :data="discontinued_rows" :filter-by="starred_filter" name="openings_table"></datatable>
                                                <span v-if="discontinued_rows.length < 1">No applicants to show.</span>
                                                <div class="" style="text-align: center;">
                                                    <datatable-pager v-model="page" type="long" :per-page="per_page" table="openings_table"></datatable-pager>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- View applicant info modal -->
        <div v-for="(applicant, a_index) in discontinued_rows" v-bind:id="'viewDiscontinued' + applicant.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Viewing: {{applicant.firstname + " " + applicant.lastname}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task user-detail-card">
                        <div class="row">
                            <div class="col-sm-12 user-detail">
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>First Name :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.firstname}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-user"></i>Last Name :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.lastname}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-calendar"></i>Age :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.age}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-touch-phone"></i>Phone :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.phonenumber}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-ui-email"></i>Email Id :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30"><a v-bind:href="'mailto:' + applicant.emailaddress">{{applicant.emailaddress}}</a></h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-graduate-alt"></i>Course :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.course}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-hat"></i>Qualification:</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.education}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-certificate"></i>Grade :</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.grades}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-businessman"></i>Current or Immediate Past Employer:</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.current_employer}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="ti ti-linkedin"></i>LinkedIn:</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30"><a href="">{{applicant.linkedinprofile}}</a></h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Referrer:</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.referrer}}</h6>
                                    </div>
                                </div>
                                <div class="row"  v-show="applicant.referrer_name !== ''">
                                    <div class="col-sm-5">
                                        <h6 class="f-w-400 m-b-30"><i class="icofont icofont-external-link"></i>Referrer Name:</h6>
                                    </div>
                                    <div class="col-sm-7">
                                        <h6 class="m-b-30">{{applicant.referrer_name}}</h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-5">
                                        <button class="btn btn-sm btn-primary m-t-5" v-on:click="restoreApplicant(applicant.id, applicant.joblisting_id)">Restore Candidate</button>
                                    </div>
                                </div>
                                <i class="small_info">Some information are not available for <b>discontinued candidates</b>, please restore candidate to view candidate's information and progress. The candidate will <b>not</b> be notified if restored.</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<style>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active{
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {background-color: #00ff00;}
    .small_info{
        font-size: 10px;
    }
</style>
<script>
import navbar1 from '../components/Navbar1.vue'
import navbar2 from '../components/Navbar2.vue'

export default {
    name: 'DiscontinuedApplications',

    data(){
        return{
            starred_filter: '',
            page: 1,
            per_page: 10,
            starred_columns: [
                {label: 'ID', field: 'id'},
                {label: 'Applicant Name', representedAs:(row)=>{
                    return row.firstname + " " + row.lastname
                }},
                {label: 'Opening',  field: 'role'},
                {label: 'Action', representedAs:(row)=>{
                    return '<button class="btn btn-sm btn-success m-1" data-toggle="modal" data-target="#viewDiscontinued'+row.id+'">View</button>'
                }, interpolate:true, sortable: false},
            ],

            discontinued_rows: [
                {
                    id: 'Loading...'
                }
            ]
        }
    },

    components:{
        navbar1,
        navbar2
    },

    mounted(){
    	$('.theme-loader').hide()

    	this.getDiscontinuedApplications()

        //this.getRoleNameById('23')
    },
    methods: {

    	getDiscontinuedApplications(){

    		var discontinued_applications = {
    			what: 'DiscontinuedApplications'
    		}

    		this.$socket.makeGetRequest(discontinued_applications)
    			.then((response)=>{
    				if(response.type == 'DiscontinuedApplications'){
    					//console.log(response.data)
    					this.discontinued_rows = response.data
    				}
    			})
    			.catch((e)=>{
    				console.log(e)
    			})
    	},

        restoreApplicant(id, opening_id){

            var c = confirm("Are you sure you want to restore this candidate?")

            if(c){
                var restore_candidate = {
                    what: 'RestoreDeletedApplicant',
                    data: {
                        applicant_id: id
                    }
                }

                this.$socket.makePostRequest(restore_candidate)
                    .then((response)=>{
                        if(response.type == 'RestoreDeletedApplicant'){
                            this.$swal.fire('Success', response.data.message, 'success')

                            setTimeout(()=>{
                                window.open('/opening/' + opening_id + '/application/' + id);
                                window.location.reload()
                            },2000)
                        }
                    })
                    .catch((e)=>{
                        console.log(e)
                    })
            }
                
        }
    },
    computed: {
        
    }
}
</script>
